export default __webpack_public_path__ + "static/media/pagebuilder_horizontal_singleline_white.1ec473a2.svg";